import React from "react"

import HebcalService from "../../../services/hebcal"
import Timeline from "../../../components/Timeline";
import { Typography } from "antd";
import { t } from "@lingui/core/macro";

const { Text } = Typography

export default class HorairesTimeline extends React.Component {

  getHoraires() {
    const { org } = this.props.context

    var hebcal = new HebcalService(org, new Date(), org.lat, org.long)

    const selectedOrg = org

    if (!selectedOrg || selectedOrg.horaires.length == 0) {
      return []
    }

    hebcal.generateHebCal()

    var horaires = {}

    for (var h of selectedOrg.horaires) {
      if (!h.dow) {
        continue
      }

      h.dow.forEach((dow) => {
        if (!horaires[dow]) {
          horaires[dow] = []
        }

        if (h.fixed) {
          horaires[dow].push({
            name: h.name,
            heure: h.heure,
            minute: h.minute,
            context:this.props.context
          })
        } else {
          var date = new Date()
          date.setDate((date.getDate() - date.getDay()) + parseInt(dow))

          var hz = new Date(hebcal.getVariableZman(h.zeman, date))

          if (hz) {
            if (h.avant) {
              hz.setMinutes(hz.getMinutes() - h.minute)
            } else {
              hz.setMinutes(hz.getMinutes() + h.minute)
            }

            if (h.round) {
              const reste = hz.getMinutes() % 5
              if (reste != 0 && reste < 2.5) {
                hz.setMinutes(hz.getMinutes() - reste)
              }

              if (reste != 0 && reste >= 2.5) {
                hz.setMinutes(hz.getMinutes() - reste + 5)
              }
            }

            // Heure murale dans le fuseau de l'org (pas celui du serveur/navigateur)
            const wc = hebcal.getWallClock(hz) || { heure: hz.getHours(), minute: hz.getMinutes() }

            horaires[dow].push({
              name: h.name,
              heure: wc.heure,
              minute: wc.minute,
              context:this.props.context
            })
          }

        }
      })
    }

    var sorted = []

    for (var dow of Object.keys(horaires).sort()) {
      var date = new Date()
      date.setDate((date.getDate() - date.getDay()) + parseInt(dow))

      sorted.push({
        dow: dow,
        date: date,
        items: horaires[dow].sort((a, b) => {
          var datea = new Date()
          datea.setHours(a.heure, a.minute)

          var dateb = new Date()
          dateb.setHours(b.heure, b.minute)

          if (datea == dateb) {
            return 0
          }
          return datea < dateb ? -1 : 1
        })

      })
    }

    return sorted
  }

  render() {
    const { org } = this.props.context
    const horaires = this.getHoraires()

    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>

          {horaires.length == 0 && (
              <div style={{ height: 500, justifyContent: "center", alignItems: "center" }}>
                <Text style={{ textAlign: "center", color: "grey" }}>{t`Désolé...`}</Text>
                <Text style={{ textAlign: "center", color: "grey", marginTop: 5 }}>
                  {t`Cet organisme n'a pas encore communiqué ses horaires.`}
                </Text>
              </div>
          )}

          {horaires.length > 0 && (
              <div style={{ width: "100%" }}>
                <Timeline
                    data={horaires}
                    TimelineHeader={() => {
                      return (
                          <div style={{ marginBottom: 10 }}>
                            <h2 style={{ color: "#000", fontWeight: "800", flexDirection: "row" }}>{t`Horaires`}</h2>
                            <div style={{
                              marginLeft: 0,
                              width: 150,
                              borderTop: "5px solid #6F98FA",
                              marginTop: 0,
                              borderRadius: 20
                            }} />
                          </div>
                      )
                    }} />
              </div>
          )}

        </div>
    )

  }
}
